<template>
  <div class="px-4 pb-4 text-center">
    <b-form>
      <b-form-group>
        <b-input v-model="childCode" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Bitte Elterncode eingeben" />
        <img v-show="childCode.length === 8" class="input-correct" :src="'./static/img/' + $current_user.role +'/check_filled.png'">
      </b-form-group>
      <alert :success="alert.success" :error="alert.error"/>
      <b-button @click="assignChild()" class="btn-neue" variant="none">
        <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
        <span v-if="!processing">Kind hinzufügen</span>
      </b-button>
    </b-form>
  </div>
</template>

<script>
// API
import codeApi from '@/api/v1/code';
import accountApi from '@/api/v1/account';
// Components
import Alert from '@/components/Helpers/Alert';
// mixins
import alert from '@/mixins/alert';

export default {
  components: { Alert },
  mixins: [alert],
  data() {
    return {
      childCode: '',
      processing: false,
    };
  },
  methods: {
    assignChild() {
      this.processing = true;

      codeApi.addChild({ code: this.childCode }).then((response) => {
        if (response.data.statuscode === 80) {
          this.alert.error = 'Der eingegebene Code konnte nicht gefunden werden.';
        } else if (response.data.statuscode === 81) {
          this.alert.error = response.data.errormessage;
        } else {
          this.alert.success = response.data.errormessage;
          this.$emit('exit', true);
          this.$bus.refreshPinboardList();
          accountApi.setDefaultPinboard(() => {
            location.href = '';
          });
          this.childCode = '';
        }
        this.processing = false;
      });
    },
    closeModal() {
      this.$emit('exit', true);
    },
    clearData() {
      this.childCode = '';
      this.alert.error = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Student/Assign.vue